import CustomTransferListWithoutActionButtons from 'Components/CustomTransferListWithoutActionButtons'
import { useAllowedClients } from 'Services/ProductManagement/Features/AllowedClient/Hooks'
import { Box, ListItemText, Typography } from '@mui/material'
import { t } from 'ttag'

interface ProductTariffAllowedApiClientsProps {
  selectedReadClients: string[]
  selectedWriteClients: string[]
  setSelectedReadClients: (selectedReadClients: string[]) => void
  setSelectedWriteClients: (selectedWriteClients: string[]) => void
}

export default function ProductTariffAllowedApiClients({
  selectedReadClients,
  selectedWriteClients,
  setSelectedReadClients,
  setSelectedWriteClients
}: Readonly<ProductTariffAllowedApiClientsProps>) {
  const { allAllowedClients, allAllowedClientsLoading } = useAllowedClients({
    excludeManagerClient: true
  })

  const allowedClientOptions = allAllowedClients.map(client => client.client_id)

  const renderItemContent = (clientId: string) => {
    const allowedClient = allAllowedClients.find(client => client.client_id === clientId)
    const labelId = `transfer-list-item-${clientId}-label`
    return (
      <ListItemText
        id={labelId}
        primary={allowedClient?.name}
        secondary={allowedClient?.client_id}
      />
    )
  }

  const handleReadClientsChange = (selectedItems: string[]) => {
    setSelectedReadClients(selectedItems)
  }

  const handleWriteClientsChange = (selectedItems: string[]) => {
    setSelectedWriteClients(selectedItems)
  }

  const isOptionsLoading = allAllowedClientsLoading === 'pending'

  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        rowGap: 2
      }}
    >
      <Box>
        <Typography variant="subtitle2" fontWeight="bold">{t`Client read permissions`}</Typography>
        <CustomTransferListWithoutActionButtons
          leftItemsHeaderText={t`All API clients`}
          rightItemsHeaderText={t`Selected API clients`}
          leftItems={allowedClientOptions}
          rightItems={selectedReadClients}
          renderItemContent={renderItemContent}
          optionsLoading={isOptionsLoading}
          handleItemsChange={selectedItems => handleReadClientsChange(selectedItems)}
          allowTransferBack={true}
          customStyles={{ maxHeight: '200px' }}
        />
      </Box>
      <Box>
        <Typography variant="subtitle2" fontWeight="bold">{t`Client write permissions`}</Typography>
        <CustomTransferListWithoutActionButtons
          leftItemsHeaderText={t`All API clients`}
          rightItemsHeaderText={t`Selected API clients`}
          leftItems={allowedClientOptions}
          rightItems={selectedWriteClients}
          renderItemContent={renderItemContent}
          optionsLoading={isOptionsLoading}
          handleItemsChange={selectedItems => handleWriteClientsChange(selectedItems)}
          allowTransferBack={true}
          customStyles={{ maxHeight: '200px' }}
        />
      </Box>
    </Box>
  )
}
